import {useState, useEffect} from "react";
import "./_title.scss";
import {IPage10, IPage15, IPageName} from "../../interfaces";
import useVMStore from "../../store";

const PageTitles: {[name in IPageName]: {title: string; subTitle?: string[]}} = {
    page2: {
        title: "Angaben zum Objekt",
        subTitle: ["Adresse des aufzunehmenden Gebäudes"],
    },
    page3: {
        title: "Scanaufnahme",
    },
    page4: {
        title: "CAD Gebäudemodell",
        subTitle: ["In welcher Dimension planen Sie Ihr Projekt?"],
    },
    page5: {
        title: "CAD Software",
        subTitle: ["Welche CAD Software nutzen Sie?"],
    },
    page6: {
        title: "Zeichnungsvorlage",
        subTitle: ["Welche Zeichnungsvorlage soll verwendet werden?"],
    },
    page7: {
        title: "Zeichnungsdetaillierung",
        subTitle: ["Welchen Detaillierungsgrad wünschen Sie?"],
    },
    page8: {
        title: "Geländedetaillierung",
        subTitle: ["Welchen Detaillierungsgrad wünschen Sie?"],
    },
    page9: {
        title: "Geschossauswahl",
        subTitle: ["Aufzunehmende Geschosse auswählen"],
    },
    page10: {
        title: "Planlayout",
    },
    page12: {
        title: "Gelände",
        subTitle: ["Welche Geländeaufnahme wünschen Sie?"],
    },
    page13: {
        title: "Datenupload",
        subTitle: ["Senden Sie uns alle vorhandenen Bestandspläne , Skizzen oder Fotos"],
    },
    page14: {
        title: "Schlussbemerkungen",
    },
    page15: {
        title: "Kontaktangaben",
    },
};

export type TitleProps = {
    page: IPageName;
};

export default function Title({page}: TitleProps) {
    const {data, setValidForm} = useVMStore();

    const title = PageTitles[page];

    const [isValid, SetIsValid] = useState<boolean>(true);

    const validateEmail = (email: string) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            );
    };

    const _data = data[page];

    useEffect(() => {
        let _isValid = true;
        if (page === "page10") {
            const {type, que, lan} = _data as IPage10;
            if (typeof que === "string") {
                _isValid = !!(que && lan) && (que && lan) !== "0";
            } else if (!type) {
                _isValid = false;
            }
        } else if (page === "page15") {
            const {vorname, nachname, email, telefon} = _data as IPage15;
            _isValid = !!(
                (vorname && nachname && validateEmail(email) && telefon)
                // (rechnungsadresse ? r_plz && r_ort : true)
            );
        } else if (["page4", "page5", "page6", "page7", "page8", "page10", "page12"].includes(page)) {
            _isValid = !!_data;
        }

        SetIsValid(_isValid);
    }, [_data]);

    useEffect(() => {
        if (isValid) {
            // if (!validForm.includes(page)) {
            setValidForm(page);
            // }
        } else {
            // const idx = validForm.indexOf(page);
            // if (idx > -1) {
            // let _validForm = [...validForm];
            // _validForm.splice(idx, 1);
            setValidForm(page, "remove");
            // }
        }
    }, [isValid]);
    return (
        <div className={"title" + (isValid ? " completed" : "")}>
            <span>{title.title}</span>
            {title.subTitle && title.subTitle.length ? title.subTitle?.map((st) => <h6 key={st}>{st}</h6>) : ""}
        </div>
    );
}
